/**
 * EscalatedEvent — renderiza tipo 'escalated'
 * payload: { motivo, a_quien, estado }
 * R-PT-07: estado de escalado visible al usuario.
 */

import { Bell } from 'lucide-react'

const A_QUIEN_LABELS = {
  orchestrator: 'Orquestador',
  humano:       'Experto humano',
  security:     'Seguridad',
}

export default function EscalatedEvent({ payload }) {
  const { motivo, a_quien, estado } = payload
  const destinatario = A_QUIEN_LABELS[a_quien] ?? a_quien

  return (
    <div className="event-escalated">
      <div className="escalated__header">
        <span className="escalated__icon"><Bell size={16} strokeWidth={1.8} aria-hidden="true" /></span>
        <span className="escalated__title">
          Esperando respuesta del {destinatario}
        </span>
      </div>
      <p className="escalated__motivo">{motivo}</p>
      {estado === 'esperando_tutor' && (
        <p className="escalated__hint">
          Puedes abrir una nueva conversación mientras esperas.
        </p>
      )}
    </div>
  )
}
